import React, { FC, PropsWithChildren, useContext, useEffect, useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTheme } from '@mui/material';
import { FrameContext } from 'react-frame-component';
import ModalContainer, { ModalContainerProps } from './ModalContainer';

export interface ModalProps extends ModalContainerProps {
    el?: string;
}
const Modal: FC<PropsWithChildren<ModalProps>> = ({ children, open, el = 'div', ...props }) => {
    const { window, document } = useContext(FrameContext);
    const [container, setContainer] = React.useState<HTMLElement>(window ? window.document.createElement(el) : null);
    const [isDesktop, setIsDesktop] = useState(false);

    const theme = useTheme();

    React.useEffect(() => {
        if (!container) {
            setContainer(window.document.createElement(el));
        } else {
            window.document.body?.appendChild(container);
        }
        return () => {
            if (container && window.document.body && window.document.body.contains(container)) {
                window.document.body.removeChild(container);
            }
        };
    }, [container]);

    useEffect(() => {
        if (open) {
            document.body.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`;
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.paddingRight = '0px';
            document.body.style.overflow = '';
        }
    }, [open]);

    useLayoutEffect(() => {
        setIsDesktop(document.body.offsetWidth > theme.breakpoints.values.md);
    }, [open]);

    const child = (
        <ModalContainer open={open} isDesktop={isDesktop} {...props}>
            {children}
        </ModalContainer>
    );
    return container ? ReactDOM.createPortal(child, container) : null;
};

export default Modal;
